import * as Sentry from '@sentry/react';

import { getIsPageTearingDown } from '~/utils/pageTeardown';

export const SuppressedErrorReason = {
  DeferredIntegrationsImport: 'deferred_integrations_import',
  ChunkLoadReload: 'chunk_load_reload',
  ChunkLoadReloadSuppressed: 'chunk_load_reload_suppressed',
  ChunkLoadDuringTeardown: 'chunk_load_during_teardown',
  ImportErrorDroppedDuringTeardown: 'import_error_dropped_during_teardown',
  ResourceLoadError: 'resource_load_error',
  CspViolation: 'csp_violation',
} as const;

export type SuppressedErrorReason =
  (typeof SuppressedErrorReason)[keyof typeof SuppressedErrorReason];

type Attributes = Record<string, string | number | boolean>;

interface Options {
  flushImmediately?: boolean;
}

export function recordSuppressedError(
  reason: SuppressedErrorReason,
  attributes: Attributes = {},
  { flushImmediately = false }: Options = {},
) {
  Sentry.logger.info('Suppressed error', {
    wouldveCausedError: true,
    reason,
    ...attributes,
  });

  if (!flushImmediately && !getIsPageTearingDown()) return;

  // The idle flush never fires once the page is going away, and callers include
  // beforeSend, where re-entering the client synchronously is unsupported.
  queueMicrotask(() => {
    void Sentry.flush().catch(() => {});
  });
}
